// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__+DMEp","icons":"Footer_icons__WsybD","icon":"Footer_icon__lWaTV"};